import { useQueryClient } from '@tanstack/react-query';
import { useAxiosInstance } from '@gov-nx/api/axios';
import { usePoQuery } from '@gov-nx/api/hooks/usePoQuery';
import { fetchDataBoxCreditQuery } from '@gov-nx/api/queries/dataBoxQuery';
import { useDataBoxStoreLists } from '@gov-nx/store/data-box/store';

export const useDataBoxCredit = (dataBoxId?: string) => {
	const queryClient = useQueryClient();

	const { connectedDataBoxesIds } = useDataBoxStoreLists();
	const { axiosInstance } = useAxiosInstance();
	const query = usePoQuery({
		enabled: dataBoxId ? connectedDataBoxesIds.includes(dataBoxId) : false,
		retry: 1,
		queryKey: dataBoxId ? ['data-box-credit', dataBoxId] : ['data-box-credit'],
		queryFn: async () =>
			dataBoxId
				? await fetchDataBoxCreditQuery(axiosInstance, dataBoxId)
				: undefined,
	});

	const refetch = async (): Promise<void> => {
		await queryClient.invalidateQueries({ queryKey: ['data-box-credit'] });
	};

	return { refetch, credit: query.data?.kredit ?? null };
};
